/// <reference lib="dom" />
import type { ChartLayer } from "../core/chart.ts";
import { type ChartAxis, ScaleOf } from "./shared.ts";

export interface GridLayerOpts {
  axis: ChartAxis;
  ticks?: number;
  values?: number[];
}

export function GridLayer(opts: GridLayerOpts): ChartLayer {
  return {
    id: `grid-${opts.axis}`,
    clip: true,
    render(root, ctx) {
      const scale = ScaleOf(ctx, opts.axis);
      const { inner } = ctx.frame;
      const values = opts.values ?? scale.ticks(opts.ticks ?? 8);
      root.selectAll<SVGLineElement, number>("line")
        .data(values)
        .join("line")
        .attr("x1", (v) => (opts.axis === "x" ? scale(v) : inner.left))
        .attr("x2", (v) => (opts.axis === "x" ? scale(v) : inner.right))
        .attr("y1", (v) => (opts.axis === "x" ? inner.top : scale(v)))
        .attr("y2", (v) => (opts.axis === "x" ? inner.bottom : scale(v)))
        .attr("stroke", ctx.theme.grid)
        .attr("stroke-width", 1)
        .attr("shape-rendering", "crispEdges");
    },
  };
}
